<script setup lang="ts">
import { useUnitStore } from '@/store/modules/unit';
const unitStore = useUnitStore();
import Sortable from 'sortablejs';
import type {  CheckboxGroupInstance, FormInstance } from 'vant';
import { getUnitList } from '@/api/modules/home'

definePage({
  name: 'edit-list',
  meta: {
    title: '编辑自选',
  },
})

const route=useRoute()


interface RowVO {
  type: number
  name: string
  id: number,
    code: string
    main: string
    num: string
    prc: string
}

const tableData = ref<RowVO[]>([])

 async function onLoad() {
  // 异步更新数据
      const { status, data } = await getUnitList({
      page: 1,
      // hold: cardActive.value,
      type:Number(route.query.id),
    })
    if (status === 1) {
      tableData.value = data.list
    }

  }
 onMounted(()=>{
  onLoad()
 })

const router = useRouter()

const back = () => {
  router.back()
}

const moveToTop = (index: number) => {
  const item = tableData.value.splice(index, 1)[0];
  tableData.value.unshift(item);
  // unitStore.updateUnit(tableData.value)
};

const realDel=ref<number[]>([])

const finish = () => {
  unitStore.deleteStock(realDel.value)
  back()
}

const checkedAll = ref(false)
// const dataCheck=ref<number[]>([])
const checkList = ref<number[]>([])
const checkboxGroup = ref<CheckboxGroupInstance | null>(null);
const checkAll = (val: boolean) => {
  checkboxGroup.value?.toggleAll(val);
}

// const check=(index:number)=>{
// dataCheck.value.push(index)
// }

const deleteUnit = () => {
  if (checkedAll.value) {
    checkList.value = []
  } else {
    if (checkList.value)
    tableData.value = tableData.value.filter(each => {
      return !checkList.value.includes(each.id)
    })
  }
  realDel.value=checkList.value
}

const show = ref(false)
// const showAdd = () => {
//   show.value = true
// }

const unitname = ref<string>('')
const formRef = ref<FormInstance | null>(null);
const onSubmit = async (action: any) => {
  // if(!unitname)return
  if (action === 'confirm') {
    try {
      try {
        await formRef.value?.validate();
        // tableData.value.push({ name: unitname.value, type: tableData.value.length+1 })
        return true;
      } catch (error) {
        return false;
      }
    } catch (error) {
      return false;
    }
  } else {
    return true; // 点击取消，直接关闭
  }
}

const dragListContainer = ref(null);
// 初始化拖拽逻辑
onMounted(async () => {
  await nextTick();
  if (dragListContainer.value) {
    Sortable.create(dragListContainer.value, {
      animation: 200,
      handle: '.drag-handle',
      ghostClass: 'row-ghost',
      onEnd: (evt: any) => {
        const { oldIndex, newIndex } = evt;
        const currRow = tableData.value.splice(oldIndex, 1)[0];
        tableData.value.splice(newIndex, 0, currRow);
        // unitStore.updateUnit(tableData.value)
      },
    });
  }
});


</script>

<template>
  <FmPageLayout navbar>
    <template #navbar-start>
      <FmIcon name="tdesign:chevron-left" class="text-24px color-[#fff]" @click="back" />
    </template>
    <template #navbar-end>
      <div class="text-18px color-[#fff]" @click="finish">完成</div>
    </template>
    <div class="bg-[#FFFFFF] h-[100%]">
      <div ref="dragList" class="group-list color-[#333333]">
        <div class="table-header van-hairline--bottom flex justify-between p-[15px] text-12px">
          <div class="col-name flex-1">名称</div>
          <div class="col-top m-r-56px">移至最前</div>
          <div class="col-drag">拖动</div>
        </div>
        <van-checkbox-group v-model="checkList" ref="checkboxGroup">
        <div ref="dragListContainer">
          <div v-for="(item, index) in tableData" :key="item.type" class="group-item van-hairline--bottom">
                <van-checkbox :name="item.id" >{{ item.name }}</van-checkbox>
              <!-- <div class="item-name" >{{ item.name }}</div> -->
              <div class="item-ops">
                <FmIcon v-if="index !== 0" name="tdesign:backtop" class="top-icon m-r-75px" @click="moveToTop(index)" />
                <div class="drag-handle">
                  <!-- <FmIcon name="tdesign:arrow-up-down-1" /> -->
                  <img src="@/assets/images/drag.png" alt="" width="20px">
                </div>
              </div>
          </div>
        </div>
      </van-checkbox-group>
      </div>
      <div class="fixed bottom-36px p-l-30px p-r-30px flex justify-between w-[100%] text-16px">
        <div>
          <van-checkbox @change="checkAll" v-model="checkedAll" >全选</van-checkbox>
        </div>
        <div class="color-[#3C78FF] ">
          <FmIcon name="tdesign:add" class="color-[#3C78FF] text-20px align-sub m-r-12px" /><span>添加到分组</span>
        </div>
        <div @click="deleteUnit">
          <FmIcon name="tdesign:delete" class="text-16px align-sub m-r-12px" /><span>删除</span>
        </div>
      </div>
    </div>

    <van-dialog v-model:show="show" title="新建分组" show-cancel-button :before-close="onSubmit">
      <van-form @submit="onSubmit" ref="formRef">
        <van-cell-group inset>
          <van-field v-model="unitname" name="unitname" placeholder="请输入分组名称"
            :rules="[{ required: true, message: '名称不可为空' }]" />
        </van-cell-group>
      </van-form>

    </van-dialog>
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.btn {
  line-height: 36px;
  vertical-align: middle;
  border: 2px solid #3c78ff;
  border-radius: 18px;
}

.group-list {
  background: #fff;
}

.group-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background-color: #fff;
}

.item-name {
  font-size: 16px;
  color: #323233;
}

.item-ops {
  display: flex;
  gap: 20px;
  align-items: center;
}

.top-icon {
  font-size: 20px;
  color: #1989fa;
  cursor: pointer;
}

.drag-handle {
  font-size: 20px;
  color: #969799;
  cursor: move;
}

/* 拖拽时的样式 */
.drag-ghost {
  background: #f7f8fa;
  opacity: 0.5;
}
</style>
